import api from './index'
import request from '@/utils/request'

/**
 * @description 查询销售员小组（不分页）
 */
export function getSalesmanGroup (params) {
  return request({
    url: `${api.getSalesmanGroup}`,
    method: 'get',
    params
  })
}
/**
 * @description 下级代理商信息详情
 */
export function subAgentDetail (data) {
  return request({
    url: `${api.subAgentDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 下级代理商信息查看
 */
export function subAgentList (data) {
  return request({
    url: `${api.subAgentList}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取销售员城市
 */
export function getSalesmanCitys (params) {
  return request({
    url: `${api.getSalesmanCitys}`,
    method: 'get',
    params
  })
}
/**
 * @description 获取各省及其地级市列表
 */
export function getSalesmanProcity (params) {
  return request({
    url: `${api.getSalesmanProcity}`,
    method: 'get',
    params
  })
}
/**
 * @description 获取代理商默认成本
 */
export function getAgFee (data) {
  return request({
    url: `${api.getAgFee}`,
    method: 'post',
    data
  })
}
/**
 * @description 新增下级代理商
 */
export function addSubAgent (data) {
  return request({
    url: `${api.addSubAgent}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取模板列表
 */
export function getTemplateList (data) {
  return request({
    url: `${api.getTemplateList}`,
    method: 'post',
    data
  })
}
/**
 * @description 根据id获取费率模板
 */
export function getTemplate (data) {
  return request({
    url: `${api.getTemplate}`,
    method: 'post',
    data
  })
}
/**
 * @description 一代代理商修改下级代理商进件权限接口
 */
export function modifyAgentApplicationStatus (data) {
  return request({
    url: `${api.modifyAgentApplicationStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 检查业务员账号是否可用
 */
export function checkSubAg (data) {
  return request({
    url: `${api.checkSubAg}`,
    method: 'post',
    data
  })
}
/**
 * @description 业务员信息查询
 */
export function querySale (data) {
  return request({
    url: `${api.querySale}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商详情
 */
export function agentDetail (data) {
  return request({
    url: `${api.agentDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 下级代理商详细信息修改
 */
export function updateSalesInfo (data) {
  return request({
    url: `${api.updateSalesInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 重置业务员密码
 */
export function resetSubAg (data) {
  return request({
    url: `${api.resetSubAg}`,
    method: 'post',
    data
  })
}
/**
 * @description 冻结业务员
 */
export function freezeSaler (data) {
  return request({
    url: `${api.freezeSaler}`,
    method: 'post',
    data
  })
}
/**
 * @description 解冻业务员
 */
export function unfreezeSaler (data) {
  return request({
    url: `${api.unfreezeSaler}`,
    method: 'post',
    data
  })
}
/**
 * @description 删除业务员
 */
export function deleteSaler (data) {
  return request({
    url: `${api.deleteSaler}`,
    method: 'post',
    data
  })
}
/**
 * @description 新增业务员
 */
export function addSales (data) {
  return request({
    url: `${api.addSales}`,
    method: 'post',
    data
  })
}
/**
 * @description 机构列表
 */
export function customerList (data) {
  return request({
    url: `${api.customerList}`,
    method: 'post',
    data
  })
}
/**
 * @description 机构详情
 */
export function customerInfo (params) {
  return request({
    url: `${api.customerInfo}`,
    method: 'get',
    params
  })
}
/**
 * @description 机构关联一代
 */
export function attachAgent (data) {
  return request({
    url: `${api.attachAgent}`,
    method: 'post',
    data
  })
}
/**
 * @description 机构关联一代
 */
export function exportCustomer (data) {
  return request({
    url: `${api.exportCustomer}`,
    method: 'post',
    data
  })
}
/**
 * @description 【合作方】大区渠道列表
 */
export function listZoneChannel (data) {
  return request({
    url: `${api.listZoneChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 【合作方】新增大区渠道经理
 */
export function addZoneOrChannel (data) {
  return request({
    url: `${api.addZoneOrChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 【合作方】大区列表
 */
export function listZone (params) {
  return request({
    url: `${api.listZone}`,
    method: 'get',
    params
  })
}
/**
 * @description 【合作方】渠道列表
 */
export function listChannel (params) {
  return request({
    url: `${api.listChannel}`,
    method: 'get',
    params
  })
}
/**
 * @description 【合作方】冻结大区渠道经理
 */
export function blockZoneChannel (data) {
  return request({
    url: `${api.blockZoneChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 【合作方】解冻大区渠道经理
 */
export function unblockZoneChannel (data) {
  return request({
    url: `${api.unblockZoneChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 【合作方】注销大区渠道经理
 */
export function deleteZoneChannel (data) {
  return request({
    url: `${api.deleteZoneChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 【合作方】代理商开通D0结算
 */
export function t0Settlement (data) {
  return request({
    url: `${api.t0Settlement}`,
    method: 'post',
    data
  })
}
